import {
  PositiveColors,
  SecondaryColors,
  TextColors,
} from '@picsart/design-system/foundation/colors';
import { FontSizes, LineHeights } from '@picsart/design-system/foundation/typography';

import { FontWeights } from '@picsart/design-system/foundation/fonts';
import { CornerRadius } from '@picsart/design-system/foundation/cornerRadius';
import { Spacings } from '@picsart/design-system/foundation/spacings';
import { createUseStyles } from 'react-jss';
import { mediaQuery } from '@picsart/rc/helpers';
import { BreakPoints, BreakPointsMedia } from '@picsart/design-system/foundation/responsive';
// import { OldBreakPoints } from '@picsart/rc/enums';

const useStyles = createUseStyles<string, { titleColor?: string }>(
  {
    root: {
      position: 'relative',
      padding: [Spacings.s24, Spacings.s0],

      // [mediaQuery(BreakPoints.Small)]: {
      '@media screen and (max-width: 766px)': {
        padding: 'initial',
      },

      // [mediaQuery(OldBreakPoints.small)]: {
      '@media screen and (max-width: 768px)': {
        padding: [Spacings.s24, Spacings.s0, Spacings.s0],
      },
    },
    wrapper: {
      display: 'flex',
      justifyContent: 'flex-start',
      alignItems: 'center',
      height: 520,
      background: 'linear-gradient(90deg, #FCFAFA 22.69%, #2B66F0 97.88%)',
      padding: [Spacings.s0, Spacings.s64],
      borderRadius: CornerRadius.r20,

      [mediaQuery(BreakPoints.Medium)]: {
        height: 470,
      },

      // [mediaQuery(BreakPoints.Small)]: {
      '@media screen and (max-width: 766px)': {
        height: 420,
        justifyContent: 'space-between',
        padding: [Spacings.s0, Spacings.s40],
      },

      // [mediaQuery(OldBreakPoints.small)]: {
      '@media screen and (max-width: 768px)': {
        background: 'linear-gradient(0deg, #F6F5F5 0%, #9EAFDF 35%, #215EEC 100%)',
        flexDirection: 'column-reverse',
        height: 768,
      },
    },
    content: {
      gap: Spacings.s24,
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'space-evenly',
      alignItems: 'flex-start',

      // [mediaQuery(OldBreakPoints.small)]: {
      '@media screen and (max-width: 768px)': {
        alignItems: 'center',
        gap: Spacings.s12,
      },
    },
    title: {
      // [mediaQuery(OldBreakPoints.small)]: {
      '@media screen and (max-width: 768px)': {
        textAlign: 'center',
      },
      '& i': {
        color: ({ titleColor }) => titleColor || 'currentColor',
        fontStyle: 'normal',
      },
    },
    description: {
      maxWidth: 450,
      fontSize: FontSizes.s20,
      fontWeight: FontWeights.medium,
      lineHeight: LineHeights.l28,

      // [mediaQuery(OldBreakPoints.small)]: {
      '@media screen and (max-width: 768px)': {
        textAlign: 'center',
      },
    },
    appsTitle: {
      display: 'block',
      fontSize: FontSizes.s16,
      fontWeight: FontWeights.semibold,
      lineHeight: LineHeights.l24,
      paddingBottom: Spacings.s12,
    },
    appsContainer: {
      // [mediaQuery(OldBreakPoints.small)]: {
      '@media screen and (max-width: 768px)': {
        textAlign: 'center',
      },

      // [mediaQuery(480)]: {
      '@media screen and (max-width: 480px)': {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
      },
    },
    appIcon: {
      display: 'inline-block',
      height: 52,
      marginRight: Spacings.s6,

      '& svg': {
        width: 144,
        height: '100%',
      },

      '&:last-child': {
        '& svg': {
          width: 164,

          // [mediaQuery(480)]: {
          '@media screen and (max-width: 480px)': {
            width: 144,
          },
        },
      },

      // [mediaQuery(480)]: {
      '@media screen and (max-width: 480px)': {
        marginRight: Spacings.s0,
      },
    },
    experience: {
      width: 'fit-content',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      background: PositiveColors.base.default,
      padding: [Spacings.s12, Spacings.s16],
      gap: Spacings.s12,
      borderRadius: CornerRadius.r8,
      fontWeight: FontWeights.semibold,
      color: TextColors.tint1,
      lineHeight: LineHeights.l24,
    },
    iconWrapper: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      borderRadius: CornerRadius.circle,
      padding: Spacings.s6,
      background: SecondaryColors.alpha.alpha80,
      '& svg': {
        fill: SecondaryColors.base.default,
      },
    },
    media: {
      display: 'flex',
      justifyContent: 'center',
      width: 530,
      position: 'absolute',
      top: 0,
      right: 80,

      [BreakPointsMedia.MD]: {
        width: 470,
        right: 40,
      },
      [BreakPointsMedia.SM]: {
        width: 470,
        right: 40,
      },
      [BreakPointsMedia.XS]: {
        width: 470,
        right: 40,
      },
      [BreakPointsMedia.XXS]: {
        width: 470,
        right: 40,
      },
      // [mediaQuery(BreakPoints.Small)]: {
      '@media screen and (max-width: 766px)': {
        width: '40%',
        position: 'initial',
      },

      // [mediaQuery(OldBreakPoints.small)]: {
      '@media screen and (max-width: 768px)': {
        width: 400,
        position: 'absolute',
        left: 0,
        right: 0,
        margin: [0, 'auto'],
      },

      // [mediaQuery(480)]: {
      '@media screen and (max-width: 480px)': {
        width: '82%',
      },
    },
    image: {
      maxWidth: '100%',
    },

    // Skeleton
    rootSkeleton: {
      height: 520,
      borderRadius: CornerRadius.r20,
    },
  },
  {
    name: 'app-download',
  },
);

export default useStyles;
